<div class="row" *ngIf="data">
  <mat-form-field>
    <mat-label>{{ data.title }}</mat-label>
    <input matInput [(ngModel)]="data.url" [required]="data.mandatory" (ngModelChange)="onChange()" (focusout)="onFocusOut()" />
  </mat-form-field>
  <mat-error *ngIf="!isValid" class="error-label">{{ 'mask.configuration.url_format_error' | translate }}</mat-error>
</div>
